import React, { useEffect, useState } from "react"
import { Alert, Platform, ScrollView, TouchableOpacity, View } from "react-native"
import MyAccount from "./MyAccount/MyAccount"
import styles from "./styles"
import SupportAndHelp from "./SupportAndHelp/SupportAndHelp"
import { Button } from "@Components/CustomButton/Button"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseColors } from "@Constants/baseStyles"
import { useSetRecoilState } from "recoil"
import { navigationAtom } from "@Recoil/navigationAtom"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { userAtom } from "@Recoil/Atom/userAtom"
import CustomSimpleModal from "@Components/Modal/CustomSimpleModal/CustomSimpleModal"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { Spacer } from "@Components/Space"
import { UserService } from "@Services/User.service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { message } from "@Constants/constant"
import { surveyResponsesAtom } from "@Recoil/Atom/surveyAtom"
import Bibliography from "./Bibliography/Bibliography"

const UserSettings = ({ navigation }) => {
    const setUserData = useSetRecoilState(userAtom)
    const setSurveyResponses = useSetRecoilState(surveyResponsesAtom)

    const [closeMyAccountModalOpen, setCloseMyAccountModalOpen] = useState(false)
    const [openLogoutModal, setOpenLogoutModal] = useState(false)
    const toggleLogoutModal = () => setOpenLogoutModal(!openLogoutModal)
    const [loading, setLoading] = useState(false)
    const handleLogout = () => {
        setUserData(null)
        setSurveyResponses({})
        LocalStorage.clearAll().then(() => {
            toggleLogoutModal()
            navigation.navigate("Root", { screen: "RegisterLoginStack", params: { screen: "LoginStack" } })
        })
    }
    const removeMyAccount = () => {
        setLoading(true)
        UserService.deleteUserAccount()
            .then((response) => {
                handleLogout()
                setLoading(false)
            })
            .catch((e) => {
                ShowToast({ type: "error", message: message.serverError })
                setLoading(false)
            })
    }

    const setCurrentPathNavigation = useSetRecoilState(navigationAtom)

    const confirmLogout = () => {
        if (Platform.OS === "web") {
            toggleLogoutModal()
        } else {
            Alert.alert("Déconnexion", "Voulez-vous vraiment vous déconnecter ?", [
                {
                    text: "Annuler",
                    onPress: () => {}
                },
                {
                    text: "Se déconnecter",
                    onPress: () => handleLogout()
                }
            ])
        }
    }
    useEffect(() => {
        const unsubscribe = navigation.addListener("blur", () => {})
        return unsubscribe
    }, [navigation])

    useEffect(() => {
        const unsubscribe = navigation.addListener("focus", () => {
            setCurrentPathNavigation("UserSettings")
        })
        return unsubscribe
    }, [navigation])

    useEffect(() => {
        return () => {
            setCurrentPathNavigation("undefined")
        }
    }, [])

    return (
        <View style={styles.container}>
            <ScrollView
                keyboardShouldPersistTaps={"handled"}
                contentContainerStyle={{ paddingBottom: 150 }}
                showsVerticalScrollIndicator={false}
            >
                <View style={styles.content}>
                    <MyAccount navigation={navigation} />

                    <Bibliography />

                    <Spacer />

                    <SupportAndHelp />

                    <View style={styles.footer}>
                        <Button
                            onPress={confirmLogout}
                            text="DECONNEXION"
                            width="60%"
                            backgroundColor={baseColors.green.primary}
                            labelColor={"white"}
                        />
                        <TouchableOpacity activeOpacity={0.5} onPress={() => setCloseMyAccountModalOpen(true)}>
                            <OpenSansText
                                style={styles.removeMyAccount}
                                textAlign={"center"}
                                fontSize={16}
                                color={baseColors.green.primary}
                                fontWeight={"bold"}
                            >
                                Supprimer mon compte
                            </OpenSansText>
                        </TouchableOpacity>
                    </View>
                </View>

                <CustomSimpleModal
                    open={closeMyAccountModalOpen}
                    toggleModal={() => (loading ? {} : setCloseMyAccountModalOpen(false))}
                >
                    <BreeSerifText style={{ padding: 15 }} textAlign={"center"} fontSize={20}>
                        Vous souhaitez supprimer votre compte ?
                    </BreeSerifText>

                    <Spacer height={5} />

                    <OpenSansText fontSize={16} textAlign={"center"}>
                        La suppression d'un compte est définitive et toutes vos données seront effacées.
                    </OpenSansText>

                    <Button
                        loading={loading}
                        onPress={() => removeMyAccount()}
                        text="supprimer mon compte"
                        width="60%"
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />

                    <TouchableOpacity
                        disabled={loading}
                        activeOpacity={0.5}
                        onPress={() => setCloseMyAccountModalOpen(false)}
                    >
                        <OpenSansText
                            style={styles.removeMyAccount}
                            textAlign={"center"}
                            fontSize={RFValue(16)}
                            color={baseColors.green.primary}
                            fontWeight={"bold"}
                        >
                            Annuler
                        </OpenSansText>
                    </TouchableOpacity>
                </CustomSimpleModal>

                <CustomSimpleModal title="Déconnexion" open={openLogoutModal} toggleModal={toggleLogoutModal}>
                    <BreeSerifText style={{ padding: 15 }} textAlign={"center"} fontSize={20}>
                        Voulez-vous vraiment vous déconnecter ?
                    </BreeSerifText>

                    <Spacer />

                    <View style={{ flexDirection: "column", alignItems: "center" }}>
                        <Button
                            loading={loading}
                            onPress={toggleLogoutModal}
                            text="Annuler"
                            width="60%"
                            backgroundColor={baseColors.orange.primary}
                            labelColor={"white"}
                        />

                        <Button
                            loading={loading}
                            onPress={handleLogout}
                            text="Se déconnecter"
                            width="60%"
                            backgroundColor={baseColors.green.primary}
                            labelColor={"white"}
                        />
                    </View>
                </CustomSimpleModal>
            </ScrollView>
        </View>
    )
}

export default UserSettings
